import { render, staticRenderFns } from "./sku-item.vue?vue&type=template&id=1f30e348&scoped=true&"
import script from "./sku-item.vue?vue&type=script&lang=js&"
export * from "./sku-item.vue?vue&type=script&lang=js&"
import style0 from "./sku-item.vue?vue&type=style&index=0&id=1f30e348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30e348",
  null
  
)

export default component.exports